import React, { PropsWithChildren } from 'react';
import { Tooltip, styled } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const StyledRecipientsContainer = styled('div')(() => ({
  display: 'flex',
  gridGap: '.5rem',
  alignItems: 'center',
  marginRight: 15,
}));

const StyledNotifyRecipientsTooltip = styled('div')(({ theme }) => ({
  marginTop: 4,
  fontSize: 15,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0,
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  textDecorationColor: '#b0b0b0',
  textUnderlineOffset: '2px',
  color: theme.palette.text.darkBodyText,

  '& svg': {
    marginTop: -2,
    marginLeft: 4,
    marginRight: 8,
  },
}));

const StyledInfoOutlined = styled(InfoOutlined)(() => ({
  fontSize: 18,
}));

const NotifyRecipientsTooltip: React.FC<
  PropsWithChildren<{ title: string }>
> = ({ title, children }) => {
  return (
    <StyledRecipientsContainer>
      <Tooltip title={title} arrow placement="top">
        <StyledNotifyRecipientsTooltip>
          <span>Notify recipients</span>
          <StyledInfoOutlined />
        </StyledNotifyRecipientsTooltip>
      </Tooltip>
      {children}
    </StyledRecipientsContainer>
  );
};

export default NotifyRecipientsTooltip;
